// extracted by mini-css-extract-plugin
module.exports = {"container":"_3czILruLhn7EcZ6Kz2sPbY","restaurantsList":"_36lgJHSZ8Uh_vqlcpM7R7I"};